import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CompanyUpdates from './updatepage/CompanyUpdate';
import BlogPosts from './blogpage/BlogPost';
import '../../../css/blogupdate.css';

const MotionDiv = motion.div;

const BlogUpdate = () => {
  const [activeTab, setActiveTab] = useState('updates');

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  const tabVariants = {
    hidden: { opacity: 0, x: 20 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.4 }
    },
    exit: { 
      opacity: 0, 
      x: -20,
      transition: { duration: 0.3 }
    }
  };

  return (
    <div className="insights-page">
      {/* Animated Background */}
      <div className="insights-bg"></div>
      
      {/* Floating Elements */}
      <div className="floating-elements">
        <MotionDiv 
          className="floating-element"
          animate={{
            y: [-20, 20, -20],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear"
          }}
        />
        <MotionDiv 
          className="floating-element"
          animate={{
            y: [20, -20, 20],
            rotate: [360, 180, 0],
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: "linear"
          }}
        />
      </div>

      <MotionDiv 
        className="insights-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {/* Hero Section */}
        <MotionDiv className="insights-hero" variants={itemVariants}>
          <div className="hero-content">
            <h1 className="insights-title">
              Stay <span className="gradient-text">Informed</span>
            </h1>
            <p className="insights-subtitle">
              Get the latest updates from POSlah and insights into the POS industry
            </p>
          </div>
        </MotionDiv>

        {/* Tab Navigation */}
        <MotionDiv className="tab-navigation" variants={itemVariants}>
          <div className="tab-container">
            <button
              className={`tab-button ${activeTab === 'updates' ? 'active' : ''}`}
              onClick={() => setActiveTab('updates')}
            >
              <span className="tab-icon">🚀</span>
              Company Updates
            </button>
            <button
              className={`tab-button ${activeTab === 'blog' ? 'active' : ''}`}
              onClick={() => setActiveTab('blog')}
            >
              <span className="tab-icon">📊</span>
              Industry Insights
            </button>
          </div>
          <div className="indicator-line">
            <div 
              className={`active-indicator ${activeTab === 'blog' ? 'slide-right' : ''}`}
            />
          </div>
        </MotionDiv>

        {/* Content Sections */}
        <MotionDiv className="content-section" variants={itemVariants}>
          <AnimatePresence mode="wait">
            {activeTab === 'updates' ? (
              <MotionDiv
                key="updates"
                variants={tabVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <CompanyUpdates />
              </MotionDiv>
            ) : (
              <MotionDiv
                key="blog"
                variants={tabVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
              >
                <BlogPosts />
              </MotionDiv>
            )}
          </AnimatePresence>
        </MotionDiv>
      </MotionDiv>
    </div>
  );
};

export default BlogUpdate;